export default function Textarea(props) {
    const {
        name,
        label,
        type,
        value,
        onChange,
        lgHideLabel,
        placeholder,
        disabled,
        error,
        rows,
        className,
        ...rest
    } = props;

    return (
        <div className={`input-group w-full flex flex-col self-end ${className}`}>
            {error && (
                <div className="relative text-status-error">
                    <span className="absolute right-0 top-1 text-xs italic">{error}</span>
                </div>
            )}
            {label && 
                <label className={`text-sm font-semibold ${error && "text-status-error"} ${lgHideLabel && "lg:hidden"}`}>{label}</label>
            }
            <textarea
                name={name}
                rows={rows}
                value={value || ""}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                className={`mt-1 text-sm ${!rows && "h-72"} border rounded w-full px-4 py-2 focus:outline-none ${error ? "border-status-error" : value ? "border-light-2" : "border-light-4"} ${className}`}
                {...rest}
            />
        </div>
    );
}

/*

Sample Props

label="Input"
type="text"
rows="1"
value={value}
onChange={(e) => setValue(e.target.value)}
placeholder="Enter text"
error="Error message"
disabled={false}

 */
